
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { updateOprQRCode } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component
export default class SystemConfigUserAdd extends Vue {
  private modalShow = false;
  private modalTitle = i18n.t("oper.customTitle");
  private formInline: objAny = {
    gunQrCodeType: "",
    oprPkId: ""
  };
  private itemData: objAny = {};
  private ruleInline: objAny = {
    gunQrCodeType: [
      {
        required: true,
        message: i18n.t("oper.gunQrCodeTypePl"),
        trigger: "change",
        type: "number"
      }
    ]
  };
  public open(item: objAny) {
    this.itemData = item;
    this.modalShow = true;
    this.formInline.oprPkId = item.oprPkId;
    this.formInline.gunQrCodeType = item.gunQrCodeType || "";
  }
  public formSubmit() {
    const formItem: objAny = this.$refs.formInline;
    console.log(formItem);
    formItem.validate((valid: boolean): void => {
      console.log(valid);
      if (valid) {
        this.submitClick();
      }
    });
  }
  async submitClick() {
    const ret = await updateOprQRCode(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.closeModal();
      this.$emit("success");
    }
  }
  public closeModal(): void {
    this.modalShow = false;
  }
}
